import { render, staticRenderFns } from "./afterInvoice.vue?vue&type=template&id=2c30ddc7&scoped=true"
import script from "./afterInvoice.vue?vue&type=script&lang=js"
export * from "./afterInvoice.vue?vue&type=script&lang=js"
import style0 from "./afterInvoice.vue?vue&type=style&index=0&id=2c30ddc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30ddc7",
  null
  
)

export default component.exports